import React from 'react'
import PropTypes from 'prop-types';


class Checkbox extends React.Component {
    render() {
        const {
            id,
            name,
            hasError,
            isChecked,
            onChange,
            value,
            children,
            className,
        } = this.props;
        const classNames = Array.isArray(className)
            ? className.join(' ')
            : className;
        const classNamesString = `checkbox-wrapper ${classNames} ${hasError ? 'error' : ''}`;

        return (
            <div
                className={classNamesString}>
                <input
                    type="checkbox"
                    id={id}
                    name={name}
                    checked={isChecked}
                    value={value}
                    onChange={onChange}
                />
                <label htmlFor={id}>
                    <span></span>
                    <div>
                        {children}
                    </div>
                </label>
            </div>
        )
    }
}

Checkbox.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    hasError: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.array,
    ]),
    isChecked: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string
    ]),
};

Checkbox.defaultProps = {
  hasError: false,
  isChecked: false,
  value: '',
  onChange: () => {},
  children: <React.Fragment></React.Fragment>,
};
export default Checkbox;



// WEBPACK FOOTER //
// ./src/custom/components/Checkbox.js